import { NeoColor, Skeleton, Stack } from "@noom/wax-component-library";

import { TreatmentCardStateContainer } from "./TreatmentCardStateContainer";

export const TreatmentCardSkeleton = () => (
  <TreatmentCardStateContainer>
    <Skeleton
      width="100%"
      height="85px"
      startColor={NeoColor.greyscale.gray1}
      endColor={NeoColor.greyscale.gray1}
    />
    <Stack spacing={2} p={4}>
      <Skeleton
        height={6}
        width="200px"
        borderRadius="md"
        startColor={NeoColor.greyscale.lightGray}
        endColor={NeoColor.greyscale.lightGray}
      />
      <Skeleton
        height={4}
        width="240px"
        borderRadius="md"
        startColor={NeoColor.greyscale.lightGray}
        endColor={NeoColor.greyscale.lightGray}
      />
      <Skeleton
        height={4}
        width="130px"
        borderRadius="md"
        startColor={NeoColor.greyscale.lightGray}
        endColor={NeoColor.greyscale.lightGray}
      />
    </Stack>
  </TreatmentCardStateContainer>
);
